import store from 'config/store'
import { filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'utils/redux'

import { processOverridePayload,processPayload } from './payloadProcessor'

export const onReceiveEmbedEpic = (action$) => action$.pipe(
  ofType("RECEIVE_EMBED_CONFIGURATION"),
  filter(() => store.name === 'controller'),
  tap(({ payload }) => processPayload(payload)),
  ignoreElements()
)

export const onReceiveEmbedOverrideEpic = (action$) => action$.pipe(
  ofType("RECEIVE_EMBED_CONFIGURATION_OVERRIDE"),
  filter(() => store.name === 'controller'),
  tap(({ payload }) => processOverridePayload(payload)),
  ignoreElements()
)
